import { splitSeriesAt } from "./split-series.js";
import type { SeriesGet, SeriesSet } from "./types.js";

/**
 * "This and following" resize from the TOP edge: shift each occurrence's start
 * to the dragged delta and set the new (longer/shorter) duration in one atomic
 * split. Because `splitSeriesAt` shifts the whole tail by `newDueAt − occurrence`
 * and applies `duration_minutes`, every following occurrence's bottom edge stays
 * put while its top edge moves — mirroring a single-occurrence top resize.
 */
export async function resizeSeriesFromStart(
  set: SeriesSet,
  get: SeriesGet,
  sourceId: string,
  occurrenceIso: string,
  newDueAt: string,
  newDurationMinutes: number,
): Promise<void> {
  await splitSeriesAt(set, get, sourceId, occurrenceIso, {
    newDueAt,
    duration_minutes: newDurationMinutes,
  });
}
